import RoleSelect from "./roleSelect.container";

export default RoleSelect;
